import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { MaterialModule } from '../../../shared/theming/material/material.module';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  private oidcSecurityService = inject(OidcSecurityService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  ngOnInit(): void {
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
      console.log('Is authenticated:', isAuthenticated);
      if (isAuthenticated) {
        this.router.navigate(['/dashboard']);
      } else {
        this.exchangeCodeForTokens();
      }
    });
  }

  exchangeCodeForTokens(): void {
    this.oidcSecurityService.getAccessToken().subscribe((token) => {
      console.log('Access Token:', token);
      if (token) {
        this.router.navigate(['/dashboard']);
      } else {
        console.error('Failed to get access token');
      }
    });
  }

  login(): void {
    this.oidcSecurityService.authorize();
  }
}
